var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "help" },
    [
      _c(
        "section",
        { attrs: { id: "getting-started" } },
        [
          _c("h1", [_vm._v("Welcome to Cadence!")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      If you are new to Cadence, here's some resources to get you started!\n    "
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._t("getting-started"),
          _vm._v(" "),
          !_vm.hideDocs
            ? _c("div", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://cadenceworkflow.io/docs/get-started/",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [_vm._v("\n        Docs\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { id: "cli" } },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      Here are a some useful common CLI commands to get started with Cadence.\n    "
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.cliCommands, function(commandGroup) {
            return _c(
              "section",
              { key: commandGroup.header },
              [
                _c("h5", [_vm._v(_vm._s(commandGroup.header))]),
                _vm._v(" "),
                _vm._l(commandGroup.commands, function(command) {
                  return _c(
                    "div",
                    { key: command.id, staticClass: "cli-command" },
                    [
                      _c("label", { attrs: { for: command.id } }, [
                        _vm._v(_vm._s(command.label))
                      ]),
                      _vm._v(" "),
                      _c("pre", { attrs: { id: command.id } }, [
                        _vm._v(_vm._s(command.value))
                      ]),
                      _vm._v(" "),
                      _vm._l(command.description, function(description, index) {
                        return _c("p", { key: index }, [
                          _vm._v(
                            "\n          " + _vm._s(description) + "\n        "
                          )
                        ])
                      })
                    ],
                    2
                  )
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm._m(6)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { id: "release-notes" } },
        [
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _vm._m(9),
          _vm._v(" "),
          _vm._t("release-notes")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("other"),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { id: "contact-us" } },
        [
          _vm._m(10),
          _vm._v(" "),
          _c("p", [_vm._v("Our office hours are 9am - 5pm PDT")]),
          _vm._v(" "),
          !_vm.hideStackOverflow
            ? _c("div", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://stackoverflow.com/questions/tagged/cadence-workflow",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [_vm._v("\n        Ask a question on Stack Overflow\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideSlack
            ? _c("div", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://join.slack.com/t/uber-cadence/shared_invite/enQtNDczNTgxMjYxNDEzLTQyYjcxZDM2YTIxMTZkMzQ0NjgxYmI3OWY5ODhiOTliM2I5MzA4NTM4MjU4YzgzZDkwNGEzOTUzNTBlNDk3Yjc",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [_vm._v("\n        Join our slack channel\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("contact-us")
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("a", { attrs: { href: "#getting-started" } }, [
        _vm._v("\n        Getting started\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-outer-container" }, [
      _c("div", { staticClass: "video-inner-container" }, [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/-BuIkhlc-RM?start=3",
            frameborder: "0",
            allow:
              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }
        }),
        _vm._v(" "),
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/aLyRyNe5Ls0",
            frameborder: "0",
            allow:
              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }
        }),
        _vm._v(" "),
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/5mBLspVKOAI",
            frameborder: "0",
            allow:
              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/samarabbas/cadence-samples",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        Code Samples\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/uber/cadence",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        Cadence source code on GitHub\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/uber/cadence-web",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        Cadence UI source code on GitHub\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("a", { attrs: { href: "#cli" } }, [
        _vm._v("\n        Common CLI commands\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://cadenceworkflow.io/docs/cli/",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        See more CLI commands\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("a", { attrs: { href: "#release-notes" } }, [
        _vm._v("\n        Latest release notes\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/uber/cadence/releases/latest",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        Cadence\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/uber/cadence-web/releases/latest",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("\n        Cadence UI\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("a", { attrs: { href: "#contact-us" } }, [
        _vm._v("\n        Contact us\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d6bb9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d6bb9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/help/index.vue
// module id = 1716
// module chunks = 0